import React from 'react';
import PropTypes from 'prop-types';
import matchMedia from 'matchmediaquery';

const breaks = {
  // Extra small devices (portrait phones, less than 576px)
  // No media query since this is the default

  // Small devices (landscape phones, 576px and up)
  small: 576,
  // Medium devices (tablets, 768px and up)
  medium: 768,
  // Large devices (desktops, 992px and up)
  large: 992,
  // Extra large devices (large desktops, 1200px and up)
  extraLarge: 1200,
};

export default class Container extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    className: undefined,
    children: null,
  };

  static childContextTypes = {
    screenSize: PropTypes.string,
  };

  static getScreenWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }

  constructor(props) {
    super(props);

    this.mqlSm = matchMedia(`(min-width: ${breaks.small}px)`);
    this.mqlMd = matchMedia(`(min-width: ${breaks.medium}px)`);
    this.mqlLg = matchMedia(`(min-width: ${breaks.large}px)`);
    this.mqlXl = matchMedia(`(min-width: ${breaks.extraLarge}px)`);

    this.state = { screenSize: 'xs' };
    this.matchedScreens = ['xs'];

    this.updateScreenSize = this.updateScreenSize.bind(this);
  }

  getChildContext() {
    return {
      screenSize: this.state.screenSize,
    };
  }

  UNSAFE_componentWillMount() {
    const screenSize = this.getScreenSize();

    this.updateScreenSize(screenSize);

    this.mqlSm.addListener(this.updateScreenSize.bind(this, 'sm'));
    this.mqlMd.addListener(this.updateScreenSize.bind(this, 'md'));
    this.mqlLg.addListener(this.updateScreenSize.bind(this, 'lg'));
    this.mqlXl.addListener(this.updateScreenSize.bind(this, 'xl'));
  }

  componentWillUnmount() {
    this.mqlSm.dispose();
    this.mqlMd.dispose();
    this.mqlLg.dispose();
    this.mqlXl.dispose();
  }

  getScreenSize() {
    const width = Container.getScreenWidth();

    if (width >= breaks.small) {
      this.matchedScreens.push('sm');
    }
    if (width >= breaks.medium) {
      this.matchedScreens.push('md');
    }
    if (width >= breaks.large) {
      this.matchedScreens.push('lg');
    }
    if (width > breaks.extraLarge) {
      this.matchedScreens.push('xl');
    }

    return this.matchedScreens[this.matchedScreens.length - 1];
  }

  updateScreenSize(size, event) {
    let screenSize = size;

    if (event) {
      if (event.matches) {
        this.matchedScreens.push(screenSize);
      } else {
        this.matchedScreens.pop();
        screenSize = this.matchedScreens[this.matchedScreens.length - 1];
      }
    }

    this.setState({ screenSize });
  }

  render() {
    const { className, children } = this.props;

    return <div className={className}>{children}</div>;
  }
}
